import React from "react"
import { Badge } from "src/components/ui/badge"

type Props = {
  label: string
  value?: string
  tags?: any[]
}

const MyPageDetailItem = ({ label, value, tags }: Props) => {
  return (
    <div className="flex flex-col sm:flex-row py-3 px-4 lg:px-6 gap-2 sm:gap-4">
      <div className="text-sm font-medium text-gray-600 w-full sm:w-40 lg:w-48 shrink-0">
        {label}
      </div>
      {value && <div className="text-sm text-gray-900 break-words">{value}</div>}
      {tags && (
        <div className="flex flex-wrap gap-2">
          {tags.map((tag, index) => {
            return (
              <Badge
                key={index}
                variant="secondary"
                className="bg-[#c5e7ff] text-gray-700 hover:bg-[#c5e7ff]"
              >
                {tag}
              </Badge>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default MyPageDetailItem
